export const generateSingleFeatureStatusWithReason = ({ title, hotelParameters }) => {
  const {
    isPmsSyncing,
    hasPhoneNumber,
    hasPhoneNumberWithVoiceAndText,
    isChurned,
    isCampaignRegisteryComplete,
    enrichedGuestPercentage,
    inviteBackIsDisabled,
    hasReservationHotline,
    hasServiceStarted,
    onlySendsOTAMessages,
    areMarketingCampaignsEnabled,
    areOTAMarketingCampaignsEnabled,
    OTArateCodesCount,
    areReviewCampaignsEnabled,
    hasTripAdvisorLink,
    hasMarketing,
    hasBasicService,
    hasCoreService,
    hasUnlimitedService,
    isChatBotEnabled,
    isUsingDefaultOpera,
    hasChatbotResponses
  } = hotelParameters

  switch (title) {
    case 'Services & fees':
      if (!hasCoreService) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Arrivals & In-house':
      if (!isPmsSyncing) {
        return {
          status: 'Warn',
          reason: 'PMS is not syncing'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Bookings':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Subscribers':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else if (!hasPhoneNumberWithVoiceAndText) {
        return {
          status: 'Bad',
          reason: 'No phone number with voice and text'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Outreach':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all marketing campaigns are enabled'
        }
      } else if (inviteBackIsDisabled) {
        return {
          status: 'Bad',
          reason: 'AutoInvite is disabled'
        }
      } else if (!hasReservationHotline) {
        return {
          status: 'Bad',
          reason: 'No reservation hotline'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (onlySendsOTAMessages) {
        return {
          status: 'Bad',
          reason: 'Only sends OTA messages'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Conversions': {
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areMarketingCampaignsEnabled || !areOTAMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all marketing campaigns are enabled'
        }
      } else if (inviteBackIsDisabled) {
        return {
          status: 'Bad',
          reason: 'AutoInvite is disabled'
        }
      } else if (!hasReservationHotline) {
        return {
          status: 'Bad',
          reason: 'No reservation hotline'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    }
    case 'OTA Outreach':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areOTAMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all marketing campaigns are enabled'
        }
      } else if (inviteBackIsDisabled) {
        return {
          status: 'Bad',
          reason: 'AutoInvite is disabled'
        }
      } else if (!hasReservationHotline) {
        return {
          status: 'Bad',
          reason: 'No reservation hotline'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (OTArateCodesCount === 0) {
        return {
          status: 'Bad',
          reason: 'No OTA rate codes'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Reviews':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areReviewCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Review campaigns are not enabled'
        }
      } else if (!hasTripAdvisorLink) {
        return {
          status: 'Bad',
          reason: 'No TripAdvisor link'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'In-property messaging':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!(hasBasicService || hasUnlimitedService)) {
        return {
          status: 'Warn',
          reason: 'Unlimited service is not enabled'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (isUsingDefaultOpera) {
        return {
          status: 'Warn',
          reason: 'Using Opera default reports'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Chatbot':
      if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!(hasBasicService || hasUnlimitedService)) {
        return {
          status: 'Warn',
          reason: 'Unlimited service is not enabled'
        }
      } else if (!isChatBotEnabled) {
        return {
          status: 'Bad',
          reason: 'Chatbot is not enabled'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (!hasChatbotResponses) {
        return {
          status: 'Warn',
          reason: 'Chatbot responses are not set'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Announcements':
      if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (!hasUnlimitedService) {
        return {
          status: 'Warn',
          reason: 'Unlimited service is not enabled'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'Campaigns':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all marketing campaigns are enabled'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (onlySendsOTAMessages) {
        return {
          status: 'Bad',
          reason: 'Only sends OTA messages'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    case 'OTA Campaigns':
      if (!isPmsSyncing) {
        return {
          status: 'Bad',
          reason: 'PMS is not syncing'
        }
      } else if (isChurned) {
        return {
          status: 'Bad',
          reason: 'Hotel is churned'
        }
      } else if (!hasMarketing) {
        return {
          status: 'Bad',
          reason: 'Core services not found'
        }
      } else if (!hasPhoneNumber) {
        return {
          status: 'Bad',
          reason: 'No phone number'
        }
      } else if (!isCampaignRegisteryComplete) {
        return {
          status: 'Bad',
          reason: 'Campaign registery is not complete'
        }
      } else if (!areOTAMarketingCampaignsEnabled) {
        return {
          status: 'Bad',
          reason: 'Not all OTA campaigns are enabled'
        }
      } else if (!hasServiceStarted) {
        return {
          status: 'Bad',
          reason: 'Service has not started'
        }
      } else if (enrichedGuestPercentage < 0.9) {
        return {
          status: 'Bad',
          reason: 'Subscribers are still processing'
        }
      } else if (OTArateCodesCount < 1) {
        return {
          status: 'Bad',
          reason: 'No rate codes'
        }
      } else {
        return {
          status: 'Good'
        }
      }
    default:
      return {
        status: 'Good'
      }
  }
}
